import { render } from "./IconForkLeft.vue?vue&type=template&id=82c66b54"
import script from "./IconForkLeft.vue?vue&type=script&lang=js"
export * from "./IconForkLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__